export default __webpack_public_path__ + "static/media/katheriner.fab7dc8c.gif";